import {
  Container,
  Wrapper,
  WrapperCategories,
  BannerDesktop,
  BannerMobile,
  SeoP,
  SubContainer,
  TitleText,
} from "./HomeElements";
import MultipleItems from "../../components/common/CarouselMulti";
import Banner from "../../components/common/Banner";
import { useTranslation } from "react-i18next";
import LoaderFull from "../../components/LoaderFull";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDontShowAgain,
  selectInfoModal,
  setDontShowAgainInfoModal,
  setShowInfoModal,
  setShowUserRegisterModal,
} from "../../features/modals/modalsSlice";
import { Helmet } from "react-helmet";
import {
  selectDetectedCountry,
  selectLogged
} from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";
//import ModalInfoByCountry from "../../components/modals/ModalInfoByCountry";
import CarouselMultiCasino from "../../components/carouselMultiCasino/CarouselMultiCasino";
import CarouselMultiDeporte from "../../components/carouselMultiDeporte/CarouselMultiDeporte";
import Banner2 from "../../components/promocionesHome/Banner2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";
const Home = ({ registro }) => {
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const logged = useSelector(selectLogged);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const detectedCountry = useSelector(selectDetectedCountry);
  const [rutaAlternaDesk, setRutaAlternaDesk] = useState(false);
  const [rutaAlternaMob, setRutaAlternaMob] = useState(false);

  const limites = useSelector(selectLimites);

  const open = useSelector(selectInfoModal);
  const dontShowAgain = useSelector(selectDontShowAgain);

  /*const handleClose = () => {
    dispatch(setShowInfoModal(false));
    dispatch(setDontShowAgainInfoModal(true));
  };*/

  useEffect(() => {
    if (window.location.href === "https://betsfactory.co/") {
      if (!logged) {
        navigate("/login");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (registro) {
      dispatch(setShowUserRegisterModal(true));
    }
  }, [registro]);

  useEffect(() => {
    if (
      detectedCountry === "VE" ||
      detectedCountry === "PE" ||
      detectedCountry === "AR"
    ) {
      setRutaAlternaDesk(`es-desk-${detectedCountry.toLowerCase()}`);
      setRutaAlternaMob(`es-mob-${detectedCountry.toLowerCase()}`);
    }

    if (detectedCountry !== "VE" || dontShowAgain) return;
    dispatch(setShowInfoModal(true));
  }, [detectedCountry]);

  const description =
    "El mejor Centro Deportivo para Apostar y Ganar en Deportes Internacionales: Futbol, Beisbol, Baloncesto, Tenis, Boxeo -Casino, Poker, Ruleta, Slots -Parley";
  const changebanner = useMediaQuery("(min-width:480px)");
  return (
    <Container>
      {/* <BasicMenu /> */}
      <Helmet>
        <title>
          Top Centro de Apuestas Deportivas Online en toda Latinoamerica
        </title>
        <link rel="canonical" href="https://masterbets365.com/" />
        <meta
          name="description"
          content={
            registro
              ? "Casino online MasterBets365 es donde podrás ganar más por tu apuesta; deportes, juegos y casino son algunas de las actividades en las que puedes participar."
              : description
          }
        ></meta>
        <meta
          property="og:title"
          content="MasterBets365 | Apuestas Deportivas | Casino Online"
        ></meta>
        <meta property="og:site_name" content="MasterBets365"></meta>
        <meta property="og:url" content="https://masterbets365.com/"></meta>
        <meta
          property="og:description"
          content="¿Estás listo para apostar y ganar desde casa? Conoce MasterBets365, casino online. Apuestas deportivas, hipódromo, ruleta y mucho más."
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:image" content=""></meta>
      </Helmet>
      {loading && <LoaderFull />}
      {/* BANNER DESKTOP */}
      <BannerDesktop>
        <Banner
          centerMode={false}
          centerPadding="0px"
          indicators={false}
          fade={false}
          show={1}
          time={3000}
          size={"472px"}
          main="home 1"
          lang={i18n.language}
          folder="desk-a"
          rutaAlterna={rutaAlternaDesk}
        />
      </BannerDesktop>

      {/* BANNER MOBILE */}
      <BannerMobile>
        <Banner
          centerMode={false}
          centerPadding="0px"
          indicators={false}
          fade={false}
          show={1}
          time={3000}
          size={"30vh"}
          lang={i18n.language}
          folder="mob-a"
          rutaAlterna={rutaAlternaMob}
        />
      </BannerMobile>
      {/* contenedor para deporte multi  */}
      <CarouselMultiDeporte></CarouselMultiDeporte>

      {/* contenedor para los espacios horizontales */}
      <SubContainer>
        {limites.tiempo_inactivo <= 0 && (
          <TitleText>
            <span className="title">{t(`home.banner-promotion`)}</span>
            <Wrapper>
              {changebanner ? (
                <Banner2
                  indicators={false}
                  fade={false}
                  show={5}
                  time={5000}
                  size={"42vh"}
                  padding={"0 0.5rem"}
                  border={"3px solid rgb(255, 206, 5)"}
                  radius={"5px"}
                  lang={i18n.language}
                  folder="desk-b"
                  main="home 2"
                />
              ) : (
                <Banner2
                  indicators={false}
                  fade={false}
                  show={2}
                  time={5000}
                  size={"42vh"}
                  padding={"0 0.5rem"}
                  border={"3px solid rgb(255, 206, 5)"}
                  radius={"5px"}
                  lang={i18n.language}
                  folder="desk-b"
                  main="home 2"
                />
              )}
            </Wrapper>
          </TitleText>
        )}

        {/* contenedor para casino  */}

        {limites.tiempo_inactivo <= 0 && (
          <CarouselMultiCasino></CarouselMultiCasino>
        )}

        {/* contenedor para deportes carousel */}
        <WrapperCategories>
          {/* <MultipleItems t={t} info="sports" /> */}
          {/* <MultipleItems t={t} info="casino" /> */}
        </WrapperCategories>

        <SeoP>{t(`home.textoFinalHome`)}</SeoP>
      </SubContainer>
    </Container>
  );
};
export default Home;
